export var AccountReactivationIA = function AccountReactivationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REACTIVATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REACTIVATION_TITLE = function ACCOUNT_REACTIVATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "pEaCXm",
    defaultMessage: [{
      "type": 0,
      "value": "Account reactivation"
    }]
  });
};
var ACCOUNT_REACTIVATION_DESCRIPTION = function ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "xhsL1w",
    defaultMessage: [{
      "type": 0,
      "value": "If you’ve previously deactivated your account, you can submit a reactivation request using the contact us option below. Note: any account verification related requests should go through My Account > Onboarding > Account Verification"
    }]
  });
};